import { render, staticRenderFns } from "./vTooltip.vue?vue&type=template&id=9de27256&scoped=true"
import script from "./vTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./vTooltip.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de27256",
  null
  
)

export default component.exports